import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Number$isNaN from "@babel/runtime-corejs3/core-js/number/is-nan";
import _Object$assign from "@babel/runtime-corejs3/core-js/object/assign";
import _JSON$stringify from "@babel/runtime-corejs3/core-js/json/stringify";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import { reactive, computed, defineComponent, ref, watch, onMounted, onUnmounted } from "@vue/composition-api";
import * as FieldComponents from "@Shared/components/sections/index";
import { formatMoneyValueLong } from "@Shared/@Utils/helpers/money";
import MortgageCalculatorsToolbar from "./mortgage-calculators-toolbar.vue";
import ReportTabLayout from "@Broker/@Modules/clients/reports/reports-containers/report-tab-layout.vue";
import * as ApplicationGetters from "@Broker/@Modules/clients/applications/application/store/application-getters";
import { useApplicationStoreGetters } from "@Broker/@Modules/clients/applications/application/store/application-helpers";
import i18n from "@Shared/i18n";
import { showToast } from "@Shared/@Utils/constants";
import SectionError from "@Shared/components/sections/section-error.vue";
import * as FinancialToolsActions from "../store/financial-tools-actions";
import { createNamespacedHelpers } from "vuex-composition-helpers";
const {
  useActions: useFinancialToolsActions
} = createNamespacedHelpers("FinancialToolsStore");
const componentName = "MinimumIncomeContainer";
export default defineComponent({
  name: componentName,
  components: _objectSpread(_objectSpread({}, FieldComponents), {}, {
    SectionError,
    ReportTabLayout,
    MortgageCalculatorsToolbar
  }),
  props: {
    initData: {
      type: Object,
      default: () => ({})
    }
  },
  setup(props) {
    const {
      CURRENT_APPLICATION
    } = useApplicationStoreGetters([ApplicationGetters.CURRENT_APPLICATION]);
    const indata = reactive({
      purchaseprice: 0,
      propertytax: 0,
      interestrate: 0,
      heatingcost: 0,
      downpayment: 0,
      condofee: 0,
      amortizPeriodMths: 0,
      monthlyDebts: 0,
      interestOnly: false,
      prepared_for: "",
      gds: 32,
      tds: 40
    });
    const outdata = ref({
      loan_to_value: 0,
      mortgage_insurance: -1,
      mortgageAmount: -1,
      total_mortgage: -1,
      monthlypi: -1,
      total_monthly_payment: -1,
      income_required: -1,
      ltv: -1
    });
    function resetResults() {
      outdata.value.loan_to_value = 0;
      outdata.value.mortgage_insurance = -1;
      outdata.value.mortgageAmount = -1;
      outdata.value.total_mortgage = -1;
      outdata.value.monthlypi = -1;
      outdata.value.total_monthly_payment = -1;
      outdata.value.income_required = -1;
      outdata.value.ltv = -1;
      return outdata;
    }
    const handleClearSelection = () => {
      indata.purchaseprice = 0;
      indata.propertytax = 0;
      indata.interestrate = 0.001;
      indata.heatingcost = 0;
      indata.downpayment = 0;
      indata.condofee = 0;
      indata.amortizPeriodMths = 300;
      indata.monthlyDebts = 0;
      indata.interestOnly = false;
      indata.gds = 32;
      indata.tds = 40;
      indata.prepared_for = "";
      resetResults();
    };
    let initialAmortizPeriodMths = 300;
    const isEmbedded = computed(() => props.initData.mortgageType);
    const populateFromApplication = () => {
      var _currentApplication$p, _currentApplication$p2;
      const theInitData = props.initData;
      const mortgageType = theInitData == null ? void 0 : theInitData.mortgageType;
      if (!mortgageType) return false;
      const currentApplication = CURRENT_APPLICATION.value;
      indata.purchaseprice = Number(((_currentApplication$p = currentApplication.property) == null ? void 0 : (_currentApplication$p2 = _currentApplication$p.details) == null ? void 0 : _currentApplication$p2["purchase-price"]) || 0);
      indata.propertytax = theInitData.propertytax;
      indata.heatingcost = theInitData.heatingcost;
      indata.condofee = theInitData.condofee;
      indata.downpayment = theInitData.downpayment;
      indata.interestrate = theInitData.interestRate;
      indata.amortizPeriodMths = theInitData.amortizPeriodMths;
      initialAmortizPeriodMths = indata.amortizPeriodMths;
      indata.monthlyDebts = theInitData.monthlyDebts;
      indata.prepared_for = theInitData.prepared_for;
      indata.interestOnly = theInitData.interestOnly;
      resetResults();
      return true;
    };
    const errorRate = theRate => {
      return theRate < 0.001 || theRate > 100.0 ? i18n.t("financial-tools.message_missing_question_2").toString() : "";
    };
    const errorMessage100k = val => {
      return val < 0 || val >= 100000 ? i18n.t("financial-tools.message_missing_question100k").toString() : "";
    };
    const errorMessageAmt = computed(() => {
      return indata.purchaseprice < 10000 || indata.purchaseprice > 100000000 ? i18n.t("financial-tools.message_missing_question_1").toString() : "";
    });
    const errorMessageRate = computed(() => {
      return errorRate(indata.interestrate);
    });
    const errorMessagePropertytax = computed(() => {
      return indata.propertytax < 0 || indata.propertytax >= 1000000 ? i18n.t("financial-tools.message_missing_question1M").toString() : "";
    });
    const errorMessageHeatingcost = computed(() => {
      return errorMessage100k(indata.heatingcost);
    });
    const errorMessageDownpayment = computed(() => {
      return indata.downpayment < 0 || indata.downpayment > 100000000 ? i18n.t("financial-tools.message_missing_question100M").toString() : "";
    });
    const errorMessageCondofee = computed(() => {
      return errorMessage100k(indata.condofee);
    });
    const errorMessagePer = computed(() => {
      if (indata.interestOnly) return "";
      const amorty = indata.amortizPeriodMths;
      return amorty < 1 * 12 || amorty > 35 * 12 ? i18n.t("financial-tools.message_missing_question_3").toString() : "";
    });
    const errorMessageMonthlyDebts = computed(() => {
      return errorMessage100k(indata.monthlyDebts);
    });
    const errorMessageGDS = computed(() => {
      return errorRate(indata.gds);
    });
    const errorMessageTDS = computed(() => {
      return errorRate(indata.tds);
    });
    const erMsgs = {
      errorMessageAmt,
      errorMessageRate,
      errorMessagePropertytax,
      errorMessageHeatingcost,
      errorMessageDownpayment,
      errorMessageCondofee,
      errorMessagePer,
      errorMessageMonthlyDebts,
      errorMessageGDS,
      errorMessageTDS
    };
    function validateInputs() {
      const fields = [{
        label: i18n.t("application-form.purchase-price").toString(),
        error: errorMessageAmt.value
      }, {
        label: i18n.t("financial-tools.property_taxes").toString(),
        error: errorMessagePropertytax.value
      }, {
        label: i18n.t("financial-tools.interest_rate").toString(),
        error: errorMessageRate.value
      }, {
        label: i18n.t("financial-tools.heating_cost").toString(),
        error: errorMessageHeatingcost.value
      }, {
        label: i18n.t("application-form.down-payment").toString(),
        error: errorMessageDownpayment.value
      }, {
        label: i18n.t("financial-tools.condo_maintenance").toString(),
        error: errorMessageCondofee.value
      }, {
        label: i18n.t("application-form.amortization").toString(),
        error: errorMessagePer.value
      }, {
        label: i18n.t("financial-tools.monthly_debts").toString(),
        error: errorMessageMonthlyDebts.value
      }, {
        label: i18n.t("application.calculations.gds").toString(),
        error: errorMessageGDS.value
      }, {
        label: i18n.t("application.calculations.tds").toString(),
        error: errorMessageTDS.value
      }];
      let valid = true;
      fields.forEach(({
        label,
        error
      }) => {
        if (error !== "") {
          showToast("error", label + ": " + error);
          valid = false;
        }
      });
      return valid;
    }
    watch(() => indata.interestOnly, isInterestOnly => {
      if (isInterestOnly) {
        indata.amortizPeriodMths = 0;
      } else {
        indata.amortizPeriodMths = initialAmortizPeriodMths;
      }
    });
    function formatMoney(val) {
      return val && val > 0 ? formatMoneyValueLong(val) : "-";
    }
    function calculateMDIPremium(mortgage, ltv) {
      const roundedLTV = Math.round(ltv * 10000) / 10000;
      let premiumRate;
      if (roundedLTV <= 0.65) {
        premiumRate = 0.006;
      } else if (roundedLTV <= 0.75) {
        premiumRate = 0.017;
      } else if (roundedLTV <= 0.8) {
        premiumRate = 0.024;
      } else if (roundedLTV <= 0.85) {
        premiumRate = 0.028;
      } else if (roundedLTV <= 0.9) {
        premiumRate = 0.031;
      } else if (roundedLTV <= 0.95) {
        premiumRate = 0.04;
      } else premiumRate = 0;
      return premiumRate;
    }
    function handleCalc() {
      if (!validateInputs()) {
        resetResults();
        return false;
      }
      const inputs = _objectSpread({}, indata);
      const inputKeys = _Object$keys(indata);
      inputKeys.forEach(function (key) {
        const v = indata[key];
        if (!_Number$isNaN(v)) inputs[key] = Number(v);
      });
      let val = inputs.purchaseprice - inputs.downpayment;
      outdata.value.mortgageAmount = val;
      val = outdata.value.mortgageAmount / inputs.purchaseprice * 10000;
      val = Math.round(val) / 10000;
      const ltv = val;
      outdata.value.ltv = ltv;
      const amortizationMths = inputs.amortizPeriodMths;
      let mibasicrate = ltv <= 0.8 ? 0 : calculateMDIPremium(outdata.value.mortgageAmount, ltv);
      val = outdata.value.mortgageAmount * mibasicrate;
      outdata.value.mortgage_insurance = val;
      val = outdata.value.mortgageAmount;
      if (outdata.value.mortgage_insurance > 0) {
        val += outdata.value.mortgage_insurance;
      }
      outdata.value.total_mortgage = val;
      const base = 1 + inputs.interestrate / (100 * 2);
      const expo = 2.0 / 12.0;
      const intFactor = Math.pow(base, expo) - 1;
      let monthlypi;
      if (inputs.interestOnly) {
        let interest = intFactor * outdata.value.total_mortgage;
        interest *= 100;
        interest = Math.round(interest) / 100;
        monthlypi = interest;
      } else {
        const tempFactor = 1 - 1 / Math.pow(intFactor + 1, amortizationMths);
        monthlypi = outdata.value.total_mortgage * intFactor / tempFactor;
      }
      outdata.value.monthlypi = monthlypi;
      val = Math.round(ltv * 100000) / 1000;
      outdata.value.loan_to_value = Math.max(0, val);
      val = monthlypi + inputs.propertytax / 12.0 + inputs.heatingcost + inputs.condofee + inputs.monthlyDebts;
      outdata.value.total_monthly_payment = val;
      const maxgdsr = inputs.gds / 100;
      const maxtdsr = inputs.tds / 100;
      const totalAnnualExpenses1 = monthlypi * 12 + inputs.propertytax + inputs.heatingcost * 12 + inputs.condofee * 12;
      const incomeRequired1 = totalAnnualExpenses1 / maxgdsr;
      if (incomeRequired1 > 0) {
        const totalAnnualExpenses2 = totalAnnualExpenses1 + inputs.monthlyDebts * 12;
        const incomeRequired2 = totalAnnualExpenses2 / maxtdsr;
        const TDS = totalAnnualExpenses2 / incomeRequired1;
        outdata.value.income_required = TDS < maxtdsr ? incomeRequired1 : incomeRequired2;
      }
      return true;
    }
    handleClearSelection();
    if (!populateFromApplication()) {
      const thisComponentCookieString = localStorage.getItem(componentName);
      if (thisComponentCookieString) {
        try {
          const thisComponentCookieData = JSON.parse(thisComponentCookieString);
          _Object$assign(indata, thisComponentCookieData);
        } catch (e) {
          console.error("Error parsing localStorage data for " + componentName + ":", e);
          localStorage.removeItem(componentName);
        }
      }
    }
    onMounted(() => {
      $("[name='purchaseprice']").trigger("focus");
    });
    onUnmounted(() => {
      if (!isEmbedded.value) localStorage.setItem(componentName, _JSON$stringify(indata));
    });
    const {
      PRINT_MINIMUM_INCOME_FORM
    } = useFinancialToolsActions([FinancialToolsActions.PRINT_MINIMUM_INCOME_FORM]);
    const isLoading = ref(false);
    const runReport = async () => {
      if (!handleCalc()) return;
      isLoading.value = true;
      const data = {
        purchasePrice: indata.purchaseprice,
        propertyTaxes: indata.propertytax,
        interestRate: indata.interestrate,
        heating: indata.heatingcost,
        downPayment: indata.downpayment,
        condoFees: indata.condofee,
        amortization: indata.amortizPeriodMths,
        debts: indata.monthlyDebts,
        interestOnly: indata.interestOnly,
        gds: indata.gds,
        tds: indata.tds,
        preparedFor: indata.prepared_for,
        ltv: outdata.value.loan_to_value,
        mortgageInsurance: outdata.value.mortgage_insurance,
        mortgageAmount: outdata.value.mortgageAmount,
        minimumIncomeRequired: outdata.value.income_required,
        totalPayment: outdata.value.total_monthly_payment,
        principalInterest: outdata.value.monthlypi
      };
      try {
        await PRINT_MINIMUM_INCOME_FORM({
          data
        });
      } catch (e) {
        console.error(e);
      }
      isLoading.value = false;
    };
    return {
      indata,
      outdata,
      erMsgs,
      isLoading,
      isEmbedded,
      formatMoney,
      handleCalc,
      handleClearSelection,
      runReport
    };
  }
});